import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  supplier: []
};

export const supplierSlice = createSlice({
  name: 'supplier',
  initialState,
  reducers: {
    setSupplier: (state, { payload }) => {
      state.supplier = [...payload];
    },
    updatePayable: (state, { payload }) => {
      const { id, newPayable } = payload;
      state.supplier = state.supplier.map(supplier =>
        supplier.id === id ? { ...supplier, payable: newPayable } : supplier
      );
    },
    clearSupplierState: (state) => {
      state = initialState;
    }
  }
});

export const { setSupplier, updatePayable, clearSupplierState } = supplierSlice.actions;

export const supplierData = (state) => state.supplier;

export default supplierSlice.reducer;
